/**
 * Helper method for concatenating the class names of a React component.
 *
 * @example
 * const dark = true;
 * const open = false;
 * classes('border', dark ? 'border-slate-50' : 'border-slate-800', open && 'shadow-sm') // => 'border border-slate-50'
 */
export function classes(...args: Array<string | false | undefined | null>): string {
  return args.filter((a): a is string => typeof a === 'string').map(a => a.trim()).join(' ');
}